<template>
  <div
    class="c_loader"
    :class="{
      c_loader_appear: loading,
      c_loader_disappear: !loading
    }"
  >
    <svg
      class="c_loader__wrap"
      xmlns="http://www.w3.org/2000/svg"
      :width="size"
      :height="size"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        class="c_loader__path"
        d="M21 12a9 9 0 1 1-6.219-8.56"

        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-dasharray="60"
        stroke-dashoffset="0"
      />
    </svg>
    <div class="c_loader__label">
      <slot name="label">
      </slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "CustomLoader",
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    size: {
      type: Number,
      default: 24
    }
  }
}
</script>

<style scoped>
  .c_loader{
    display: flex;
    justify-content: space-around;
    align-items: center;
    pointer-events: none;
  }

  .c_loader_appear {
    -webkit-animation: appearLoad 500ms ease forwards;
    animation: appearLoad 500ms ease forwards;
  }

  .c_loader_disappear {
    -webkit-animation: disappearLoad 500ms ease forwards;
    animation: disappearLoad 500ms ease forwards;
  }

  .c_loader__label{
    display: flex;
    padding: .2rem;
  }

  .c_loader__wrap{
    -webkit-animation: rotateLoad 1.25s cubic-bezier(.77,0,.42,1) forwards infinite;
    animation: rotateLoad 1.25s cubic-bezier(.77,0,.42,1) forwards infinite;
  }

  .c_loader__path{
    transition: all .5s ease;
    -webkit-animation: animateLoad 2.5s cubic-bezier(.77,0,.42,1) forwards infinite;
    animation: animateLoad 2.5s cubic-bezier(.77,0,.42,1) forwards infinite;
  }

  @keyframes animateLoad {
    0% {
      stroke-dashoffset: 15;
    }
    50% {
      stroke-dashoffset: 50;
    }
    100% {
      stroke-dashoffset: 15;
    }
  }

  @keyframes rotateLoad {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(720deg);
    }
  }

  @keyframes appearLoad {
    from{
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }

  @keyframes disappearLoad {
    from {
      opacity: 1;
    }
    to {
      opacity: 0;
    }
  }
</style>
